(function (angular) {

  angular.module("alk.sso", []);

})(window.angular);

require("./sso.service");



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-sso/module.js